var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.00082C7.48 2.00037 2.99963 6.48 2.99918 12C2.99873 17.52 7.47836 22.0004 12.9984 22.0008C18.5184 22.0013 22.9987 17.5216 22.9992 12.0016C22.9996 6.48164 18.52 2.00127 13 2.00082ZM11.9996 7.00074L11.9994 9.00074L13.9994 9.0009L13.9996 7.0009L11.9996 7.00074ZM11.9993 11.0007L11.9988 17.0007L13.9988 17.0009L13.9993 11.0009L11.9993 11.0007ZM4.99918 12.0002C4.99882 16.4102 8.58852 20.0005 12.9985 20.0008C17.4085 20.0012 20.9988 16.4115 20.9992 12.0015C20.9995 7.59148 17.4098 4.00118 12.9998 4.00082C8.58984 4.00046 4.99954 7.59016 4.99918 12.0002Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo24Px);
export default __webpack_public_path__ + "static/media/info_24px.323e6a47bd909563a4d0d3ec0c0215d8.svg";
export { ForwardRef as ReactComponent };